import { render, staticRenderFns } from "./KeyboardAte.vue?vue&type=template&id=6298847d&scoped=true&"
import script from "./KeyboardAte.vue?vue&type=script&lang=js&"
export * from "./KeyboardAte.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardAte.vue?vue&type=style&index=0&id=6298847d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6298847d",
  null
  
)

export default component.exports